// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"367ead0b","394":"37558c04","501":"5fedc178","642":"33b9f6ad","656":"bb180fbd","880":"9088c01e","900":"0cc8bd58","922":"26c84d2e"}[chunkId] + ".css";
};